"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeFonts = void 0;
exports.themeFonts = {
    MontserratRegular: 'Montserrat-Regular',
    MontserratBold: 'Montserrat-Bold',
    MontserratSemiBold: 'Montserrat-SemiBold',
    MontserratLight: 'Montserrat-Light',
    MontserratMedium: 'Montserrat-Medium',
    Satoshi: 'Satoshi',
    SatoshiBold: 'SatoshiBold',
    Roboto: 'Roboto, sans-serif',
    SFProRegular: 'SFProText-Regular'
};
//# sourceMappingURL=typography.js.map